import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { MapPinIcon, CalendarIcon, BanknoteIcon, ArrowRightIcon } from 'lucide-react';
import { Project } from '../../data/projects';
interface ProjectCardProps {
  project: Project;
  index: number;
}
export function ProjectCard({
  project,
  index
}: ProjectCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: index * 0.05
  }} data-id="element-352" data-mp="1842fy0petcjz">
      <Card hover className="h-full flex flex-col" data-id="element-353" data-mp="1i4l61d7khpac">
        <div className="flex items-start justify-between mb-3" data-id="element-354" data-mp="1d46uhl6rbx7k">
          <span className="inline-block bg-au-green-light text-au-green text-xs font-semibold px-3 py-1 rounded-full" data-id="element-355" data-mp="1d605fcoel3ld">
            {project.sector}
          </span>
          <StatusPill status={project.status} data-id="element-356" data-mp="2oi10187y7m91">
            {project.status.toUpperCase()}
          </StatusPill>
        </div>

        <h3 className="text-xl font-bold text-charcoal mb-3 leading-snug" data-id="element-357" data-mp="29ck84ufs0hok">
          {project.title}
        </h3>

        <div className="flex items-start gap-2 text-sm text-gray-600 mb-3" data-id="element-358" data-mp="2edq1muh9g8z5">
          <MapPinIcon size={16} className="flex-shrink-0 mt-0.5" data-id="element-359" data-mp="2jbj9dry7pb1j" />
          <span data-id="element-360" data-mp="2oacm3i5ocy0n">{project.countries.join(', ')}</span>
        </div>

        <p className="text-gray-600 text-sm mb-4 flex-1" data-id="element-361" data-mp="1qmcagruuijfr">
          {project.description}
        </p>

        <div className="space-y-2 pt-4 border-t border-gray-border" data-id="element-362" data-mp="1vlf5djh439a0">
          <div className="flex items-center justify-between text-sm" data-id="element-363" data-mp="1vjb130faw897">
            <div className="flex items-center gap-2 text-gray-600" data-id="element-364" data-mp="20jqd9onuj9pl">
              <BanknoteIcon size={16} data-id="element-365" data-mp="25bqjtzyf90v5" />
              <span data-id="element-366" data-mp="25crva5jcnpde">Budget</span>
            </div>
            <span className="font-bold text-au-green" data-id="element-367" data-mp="17w2umf64yt5l">{project.budget}</span>
          </div>
          <div className="flex items-center justify-between text-sm" data-id="element-368" data-mp="1cuxnyb1qc03y">
            <div className="flex items-center gap-2 text-gray-600" data-id="element-369" data-mp="1ct2zwnv5vrvn">
              <CalendarIcon size={16} data-id="element-370" data-mp="14t6kxau5lhfs" />
              <span data-id="element-371" data-mp="14rvet4d8jxli">Timeline</span>
            </div>
            <span className="font-medium text-charcoal" data-id="element-372" data-mp="zu3p8h02cnkh">
              {new Date(project.startDate).getFullYear()}
              {project.endDate ? ` – ${new Date(project.endDate).getFullYear()}` : ''}
            </span>
          </div>
        </div>

        <button className="mt-4 flex items-center gap-1 text-au-green font-medium text-sm hover:gap-2 transition-all" data-id="element-373" data-mp="luu8ng7y3rfz">
          <span data-id="element-374" data-mp="gxc8ae7zukjl">View Project Details</span>
          <ArrowRightIcon size={16} data-id="element-375" data-mp="gynbocxj1qa6" />
        </button>
      </Card>
    </motion.div>;
}